<route>
{
  "name": "messages",
  "meta": {
    "order": 4.01,
    "isVisible": true,
    "iconName": "mdi-message",
    "roles": ["Admin"]
  }
}
</route>
<template>
  <div class="mt-3">
    <page-title
      :title="$t('pages.messages.title')"
    >
     <div
       class="mb-3">
         <v-btn
          class="w-sm-100"
           to="/messages/add"
           color="success">
           <v-icon
             class="mr-2"
             small>
             mdi-plus
           </v-icon>
       {{ $t('pages.messages.add') }}
         </v-btn>
      </div>
    </page-title>
        <v-row
          class="px-3 mb-3"
          >
          <v-col
            :sm="6"
            >
            <form-item
              v-model="userId"
              type="autocomplete"
              :items="userList"
              icon="mdi-account-circle"
              :label="$t('enums.userList')"
              :placeholder="$t('enums.placeholders.userList')"
              ></form-item>
          </v-col>
          <v-col
            v-if="userListLoading"
            class="d-flex align-self-center mt-5"
            :sm="1"
            >
            <v-progress-circular
              indeterminate
              color="primary"
              :value="20"
              />
          </v-col>
          <v-col
            :sm="12"
            >
            <v-btn
              large
              class="px-5 ml-1 mr-auto"
              color="primary"
              @click="getUserMessages"
              >
              {{ $t('enums.getUserMessages') }}
            </v-btn>
          </v-col>
        </v-row>
    <v-data-table
      align-center
      class="report-table"
      :headers="headers"
      :hide-default-header="isMobile"
      :options.sync="pages"
      :items="messagesList"
      :loading="isLoading"
      disable-sort
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td class="data-min-td min-20"> {{ props.item.title }} </td>
          <td class="data-min-td min-20"> {{ props.item.body.substring(0,60) }}
            <span v-if="props.item.body.length > 60">...</span>
          </td>
          <td v-if="props.item.isRead" class="data-min-td success--text"> {{ isRead }} </td>
          <td v-else class="data-min-td error--text"> {{ isntRead }} </td>
          <td class="data-min-td"> {{ toJalali(props.item.dateAt) }} </td>
          <td class="data-min-td">
            <v-btn
              small
              class="px-1"
              color="primary"
              @click="showMessageModal(props.item)"
              >
              <v-icon
              class="ml-1"
                small>
                mdi-message
              </v-icon>
              {{ $t('enums.showMessage') }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      width="700"
      >
      <v-card class="px-3 pb-3">
        <v-card-title class="headline">
          {{ $t('enums.showMessage') }}
        </v-card-title>
      <v-card
        outlined
        class="border-box"
        >
        <v-card
          flat
          class="d-flex">
          <v-layout
            flex-column
            justify-right
            align-center
            class="pa-2"
            >
            <v-row>
              <v-card-text>{{$t('enums.messageTitle') }} : {{ message.title }}</v-card-text>
            </v-row>
        <v-row>
          <v-card-text>{{$t('enums.messageBody') }} : {{ message.body}}</v-card-text>
        </v-row>
          </v-layout>
        </v-card>
      </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { JalaliDateTime } from 'jalali-date-time'
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data () {
    return {
      message: {},
      pages: {},
      userId: null,
      isLoading: false,
      dialog: false,
      userList: [],
      messagesList: [],
      isRead: this.$t('enums.isRead'),
      isntRead: this.$t('enums.isntRead')
    }
  },
  watch: {
    allUsers: {
      handler () {
        this.setUserList()
      },
      deep: true
    }
  },
  created () {
    if (this.allUsers.length) {
      this.setUserList()
    }
  },
  computed: {
    ...mapGetters({
      allUsers: 'users/users',
      hasUsersSucceeded: 'users/hasUsersSucceeded'
    }),
    headers () {
      return [
        {
          text: this.$t('enums.headers.messageTitle'),
          value: 'title'
        },
        {
          text: this.$t('enums.headers.messageBody'),
          value: 'body'
        },
        {
          text: this.$t('enums.headers.status'),
          value: 'isRead'
        },
        {
          text: this.$t('enums.headers.sendingDate'),
          value: 'dateAt'
        },
        {
          text: this.$t('enums.headers.actions'),
          value: 'actions'
        }
      ]
    },
    userListLoading () {
      return !this.hasUsersSucceeded
    },
    isMobile () {
      return window.innerWidth < 767
    }
  },
  methods: {
    ...mapActions({
      getMessagesByUserId: 'messages/getMessagesByUserId',
      showToast: 'snackbar/showToastMessage'
    }),
    getUserMessages () {
      this.isLoading = true
      this.getMessagesByUserId({ userid: this.userId }).then(response => {
        this.messagesList = response.data
        this.isLoading = false
      })
    },
    showMessageModal (val) {
      this.message = val
      this.dialog = true
    },
    setUserList () {
      this.userList = this.allUsers.map(user => {
        return { text: user.fullName, value: user.id }
      })
    },
    toJalali (date) {
      const jalali = JalaliDateTime()
      return jalali.toDate(new Date(date))
    }
  }
}
</script>
